import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import { getLoaderProps, StoreLoaderProps } from "@store/theme/props/loader";
import React, { FC, useEffect, useState } from "react";

export interface Props {
    height?: string;
    size?: number;
}

const StoreLoader: FC<Props> = ({ height, size }) => {
    const [styles, setStyles] = useState<StoreLoaderProps>(getLoaderProps(height, size));

    useEffect(() => {
        setStyles(getLoaderProps(height, size));
    }, [height, size]);

    return (
        <StyledWrapper {...styles.wrapper}>
            <LoadingSpinner {...styles.spinner} />
        </StyledWrapper>
    );
};

export default StoreLoader;
